import { ComponentPropsWithRef } from 'react';
import styled, { FlattenSimpleInterpolation } from 'styled-components';
import tw from 'tailwind.macro';
import { withCurrentLocale } from '../../utils/i18nUrls';
import { BUTTON_VARIANT_STYLE } from '../Forms/Button';
import { P0 } from '../Typographies/Paragraph';

const StyledLink = styled(P0)<LinkProps>`
  ${BUTTON_VARIANT_STYLE.LINK}
  &:visited {
    ${BUTTON_VARIANT_STYLE.LINK}
  }

  ${({ isObfuscated }) => isObfuscated && tw`cursor-pointer`}

  ${({ customStyle }) => customStyle}
`;

type LinkProps = {
  customStyle?: FlattenSimpleInterpolation;
  isObfuscated?: boolean;
} & ComponentPropsWithRef<'a'>;

export const Link = (props: LinkProps) => {
  // Internal links keep the language of the current URL (/en/...).
  const href = withCurrentLocale(props.href);

  if (props.isObfuscated) {
    return (
      <StyledLink
        {...props}
        as="span"
        href={undefined}
        onClick={() => {
          if (href) {
            window.open(href, props.target || '_self');
          }
        }}
        target={undefined}
      >
        {props.children}
      </StyledLink>
    );
  }

  return <StyledLink as={'a'} {...props} href={href} />;
};
